// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dL-7","question":"styles_question__3DP_9","description":"styles_description__2YmOO"};